{
    "variables": [
        {
            "name": "response",
            "type": "text"
        }
    ],
    "timestamp": 1711125085,
    "paths": [
        {
            "object_id": "1710883083420_53899",
            "parent": "1710883081288_64644",
            "child": "1710883040374_33334_0"
        },
        {
            "object_id": "1710883095248_38624",
            "parent": "1710883040374_80871",
            "child": "1710883093340_17280_0"
        }
    ],
    "children": [
        {
            "object_id": "1710883040374_33334_0",
            "index": 0,
            "text": "",
            "path": {
                "object_id": "1710883083420_53899"
            },
            "parent": "1710883040374_80871"
        },
        {
            "object_id": "1710883081288_67118_0",
            "index": 0,
            "text": "",
            "path": null,
            "parent": "1710883081288_64644"
        },
        {
            "object_id": "1710883081288_89271_1",
            "index": 1,
            "text": "Custom Response",
            "path": null,
            "parent": "1710883081288_64644"
        },
        {
            "object_id": "1710883093340_17280_0",
            "index": 0,
            "text": "",
            "path": {
                "object_id": "1710883095248_38624"
            },
            "parent": "1710883093340_98602"
        }
    ],
    "blocks": [
        {
            "object_id": "1710883040374_80871",
            "name": "Model Name, Admin Prompt, User Input",
            "x": -3558,
            "y": -872,
            "width": 5,
            "height": 3,
            "is_statistic": 0,
            "type": {
                "name": "action"
            },
            "data": {
                "variables": [
                    {
                        "value": "llm(\\'open-mixtral-8x7b\\', \\'\\', \\'Bonjour tu vas bien ?\\')",
                        "is_operation": true,
                        "index": "0",
                        "variable": {
                            "id": 14105,
                            "name": "response",
                            "public": 0,
                            "global": 0,
                            "global_value_test": "",
                            "global_value_prod": "",
                            "type": {
                                "id": 1,
                                "name": "text"
                            }
                        }
                    }
                ]
            },
            "action_type": {
                "id": 5,
                "name": "set_var"
            }
        },
        {
            "object_id": "1710883081288_64644",
            "name": "Prompt",
            "x": -3273,
            "y": -838,
            "width": 5,
            "height": 3,
            "is_statistic": 0,
            "type": {
                "id": 4,
                "name": "propos"
            },
            "data": {
                "block_id": 108871,
                "messages": [
                    {
                        "type": "text",
                        "content": "[RESPONSE]\n"
                    }
                ],
                "responses": [
                    {
                        "type": "custom",
                        "content": "Custom Response"
                    }
                ],
                "variable_redirect": null
            }
        },
        {
            "object_id": "1710883093340_98602",
            "name": "Mixtral",
            "x": -3812,
            "y": -876,
            "width": 5,
            "height": 2,
            "is_statistic": 0,
            "type": {
                "id": 3,
                "name": "scenario"
            },
            "data": {
                "block_id": 108872,
                "basic": 0
            }
        }
    ],
    "coords": {
        "y": {
            "max": -838,
            "min": -876
        },
        "x": {
            "max": -3273,
            "min": -3812
        }
    }
}